import { CoreIcon } from '../core-icon';
import qrcodeCircleGraySVG from '../../assets/icons/qrcode-circle-gray.svg';
import type { IconProps } from '../core-icon';

export const QrcodeCircleGrayIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={qrcodeCircleGraySVG} {...props} />;
};
